const FIREBASE_API_KEY= 'AIzaSyA5sPlupW_n1XEt6xsw_Y7aAZKltGEFyXw';

const RapidAPI_Key= '036435e0f1msh926c9c4f8be6a0dp15eb98jsnfed03486c09f';


export  {FIREBASE_API_KEY, RapidAPI_Key};

